var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocuments = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 24
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "documents_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 4952",
  fill: "currentColor",
  d: "M0 0h18v24H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 33341",
  clipPath: "url(#documents_svg__a)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13081",
  d: "M16.662 0H4.8a1.369 1.369 0 0 0-1.336 1.4v2.608H1.338A1.37 1.37 0 0 0 0 5.4v17.2A1.37 1.37 0 0 0 1.338 24H13.2a1.37 1.37 0 0 0 1.338-1.4v-2.608h2.126A1.37 1.37 0 0 0 18 18.6V1.4A1.369 1.369 0 0 0 16.662 0m-4.126 22H2V6.008h10.536ZM16 17.992h-1.464V5.4A1.37 1.37 0 0 0 13.198 4H5.464V2H16Z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13082",
  d: "M10.787 8.854H3.755a.75.75 0 0 0 0 1.5h7.032a.75.75 0 1 0 0-1.5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13083",
  d: "M10.787 11.787H3.755a.75.75 0 0 0 0 1.5h7.032a.75.75 0 0 0 0-1.5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13084",
  d: "M10.787 14.721H3.755a.75.75 0 0 0 0 1.5h7.032a.75.75 0 0 0 0-1.5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13085",
  d: "M10.787 17.654H3.755a.75.75 0 0 0 0 1.5h7.032a.75.75 0 1 0 0-1.5"
}))));
export default SvgDocuments;